import utils from '@bigcommerce/stencil-utils';
import $ from 'jquery';
import 'slick-carousel';

window.stencilUtils = utils;

const loadScript = (src, attributes = {}) => new Promise((resolve, reject) => {
    const existing = document.querySelector(`script[src="${src}"]`);

    if (existing) {
        if (existing.dataset.loaded === 'true') {
            resolve(existing);
            return;
        }

        existing.addEventListener('load', () => resolve(existing), { once: true });
        existing.addEventListener('error', reject, { once: true });
        return;
    }

    const script = document.createElement('script');
    script.src = src;

    Object.entries(attributes).forEach(([key, value]) => {
        script.setAttribute(key, value);
    });

    script.addEventListener('load', () => {
        script.dataset.loaded = 'true';
        resolve(script);
    }, { once: true });
    script.addEventListener('error', reject, { once: true });

    document.head.appendChild(script);
});

const ready = callback => {
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', callback, { once: true });
    } else {
        callback();
    }
};

const initializeSwiper = selector => {
    if (!window.Swiper || !document.querySelector(selector)) return;

    new window.Swiper(selector, {
        spaceBetween: 30,
        loop: true,
        autoplay: {
            delay: 2500,
            disableOnInteraction: false,
        },
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
        navigation: selector === '.product-slider' ? {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        } : undefined,
    });
};

const initializeSwiperSliders = () => {
    loadScript('https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js')
        .then(() => {
            initializeSwiper('.product-slider');
            initializeSwiper('.product-slider-mobile');
        })
        .catch(() => {});
};

const loadFontAwesome = () => {
    loadScript('https://example.com/fontawesome/v7.0.1/js/fontawesome.js', {
        'data-auto-replace-svg': 'nest',
    });
    loadScript('https://example.com/fontawesome/v7.0.1/js/solid.js');
    loadScript('https://example.com/fontawesome/v7.0.1/js/brands.js');
};

const updateAccountHeading = () => {
    $('.account').siblings('.page-heading').text('My Account');
    $('.account .page-heading').text('My Account');
};

const toggleSectionsBasedOnScreenSize = () => {
    const sectionToShow = document.querySelector('.subcat');
    const sectionToHide = document.querySelector('.subcategory-area');

    if (!sectionToShow && !sectionToHide) return;

    if (window.innerWidth <= 768) {
        sectionToShow?.classList.remove('hidden');
        sectionToHide?.classList.add('hidden');
    } else {
        sectionToShow?.classList.add('hidden');
        sectionToHide?.classList.remove('hidden');
    }
};

const initializeStickyHeader = () => {
    const header = document.getElementById('myHeader');

    if (!header) return;

    const sticky = header.offsetTop + 200;

    window.addEventListener('scroll', () => {
        if (window.pageYOffset > sticky) {
            header.classList.add('header_fixed');
            $('body').addClass('body_top');
        } else {
            header.classList.remove('header_fixed');
            $('body').removeClass('body_top');
        }
    });
};

const initializeResponsiveMenu = () => {
    $('#menu_responsive li div, #menu_responsive li ul')
        .prev('a')
        .addClass('sub_nav')
        .after('<span class="subcat-expand"></span>');
    $('#menu_responsive li div, #menu_responsive li ul').hide();
    $('#menu_responsive .subcat-expand').on('click', function onSubcatExpandClick() {
        $(this).toggleClass('subcat-expanded');
        $(this)
            .siblings('#menu_responsive div, #menu_responsive ul')
            .slideToggle('slow')
            .closest('#menu_responsive div, #menu_responsive ul')
            .toggleClass('subcatActive');
    });
};

const initializeLoginPopup = () => {
    $('.login_popup').on('click', function onLoginPopupClick() {
        $('.dropdown_popup').toggle();
        $(this).toggleClass('open_popup');
    });
};

const initializeSubcatExpandVisibility = () => {
    $('.navPage-subMenu-item').each(function eachSubMenuItem() {
        const $subcatExpand = $(this).find('.subcat-expand');
        const $navPageChildList = $(this).find('.navPage-childList');

        if (!$navPageChildList.length) {
            $subcatExpand.hide();
        }
    });
};

const initializeMobileFlyoutSync = () => {
    const SCOPE_SEL = '#menu_responsive.navPages-container[data-menu]';
    const isMobile = () => window.matchMedia('(max-width: 990px)').matches;
    const inScope = el => !!$(el).closest(SCOPE_SEL).length;

    const setFlyoutDisplay = ($fromTarget, show) => {
        const $flyout = $fromTarget.closest(SCOPE_SEL).find('.megaFlyout').first();
        if (!$flyout.length) return;

        const value = show ? 'block' : 'none';
        $flyout.css('display', value);
        $flyout.find('.megaFlyout__inner, ul.megaFlyout__rail').css('display', value);
    };

    const initialSync = () => {
        if (!isMobile()) return;

        const $scope = $(SCOPE_SEL);
        if (!$scope.length) return;

        $scope.find('.megaFlyout, .megaFlyout__inner, ul.megaFlyout__rail').css('display', 'none');
        $scope.find('.subcatActive').each(function eachActiveSubcat() {
            setFlyoutDisplay($(this), true);
        });
    };

    if (!document.body) return;

    initialSync();

    const observer = new MutationObserver(mutations => {
        if (!isMobile()) return;

        mutations.forEach(mutation => {
            if (mutation.type !== 'attributes' || mutation.attributeName !== 'class') return;
            if (!inScope(mutation.target)) return;

            const $target = $(mutation.target);
            setFlyoutDisplay($target, $target.hasClass('subcatActive'));
        });
    });

    observer.observe(document.body, {
        attributes: true,
        subtree: true,
        attributeFilter: ['class'],
    });

    $(window).on('resize', initialSync);
};

const initializeReviewScroll = () => {
    $('.custom_product .body .go_review').on('click', function onReviewClick() {
        const elementId = $(this).attr('data-id');
        const $target = $(`#${elementId}`);
        const reviewTabLink = $('.productView-description .productView-reviewTabLink')[0];

        if (!$target.length) return;

        $('html, body').animate({
            scrollTop: $target.offset().top - 150,
        }, 1200);

        if (reviewTabLink) {
            reviewTabLink.click();
        }
    });
};

const initializeSlickSlider = (selector, options) => {
    const $slider = $(selector);

    if (!$slider.length || typeof $slider.slick !== 'function') return;

    $slider.not('.slick-initialized').slick(options);
};

const initializeSlickSliders = () => {
    initializeSlickSlider('.cat_slider_block ul', {
        infinite: false,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 479,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 319,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    });

    const productSliderOptions = {
        dots: false,
        infinite: false,
        speed: 300,
        slidesToShow: 5,
        slidesToScroll: 1,
        variableWidth: true,
        prevArrow: '<div class="arrow-left"></div>',
        nextArrow: '<div class="arrow-right"></div>',
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: true,
                },
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                },
            },
        ],
    };

    initializeSlickSlider('.slider-featured-products', productSliderOptions);
    initializeSlickSlider('.top-selling-products', productSliderOptions);
    initializeSlickSlider('.slider-subcategory-filters', {
        dots: false,
        infinite: true,
        speed: 300,
        slidesToShow: 4,
        slidesToScroll: 1,
        variableWidth: true,
        prevArrow: '<div class="arrow-left"></div>',
        nextArrow: '<div class="arrow-right"></div>',
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: false,
                },
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                },
            },
        ],
    });
};

const initializeDesktopNavHover = () => {
    $('.navPage-subMenu-list .navPage-subMenu-item').on('mouseenter', function onSubMenuMouseEnter() {
        $(this).parent().children('.navPage-subMenu-item').removeClass('hover_active');
        $(this).addClass('hover_active');
    });

    $('.navPages-item .navPages-action').on('click', () => {
        $('.navPage-subMenu-list .navPage-subMenu-item').removeClass('hover_active');
        $('.navPage-subMenu-list .navPage-subMenu-item:first-child').addClass('hover_active');
    });
};

// new mega menu like GI.
const initializeProductsCascadeMenu = () => {
    const cascades = document.querySelectorAll('[data-products-cascade]');

    if (!cascades.length) return;

    cascades.forEach(cascade => {
        const toggle = cascade.querySelector('[data-products-cascade-toggle]');
        const menu = cascade.querySelector('[data-products-cascade-menu]');
        const closeButton = cascade.querySelector('[data-products-cascade-close]');
        const overlay = cascade.querySelector('[data-products-cascade-overlay]');
        const toggleIcon = cascade.querySelector('.products-cascade__toggle-icon');

        if (!toggle || !menu || !closeButton || !overlay) return;

        const positionCloseButton = () => {
            const menuRect = menu.getBoundingClientRect();
            const visiblePanels = cascade.querySelectorAll(
                '.products-cascade__panel--root, .products-cascade__panel.is-active',
            );
            let rightEdge = menuRect.left;

            visiblePanels.forEach(panel => {
                rightEdge = Math.max(rightEdge, panel.getBoundingClientRect().right);
            });

            const desiredPosition = rightEdge - menuRect.left + 12;
            const maximumPosition = window.innerWidth - menuRect.left - 46;

            closeButton.style.left = `${Math.max(12, Math.min(desiredPosition, maximumPosition))}px`;
        };

        const resetPanels = () => {
            cascade.querySelectorAll('.products-cascade__item.is-active').forEach(item => item.classList.remove('is-active'));
            cascade.querySelectorAll('.products-cascade__panel.is-active').forEach(panel => panel.classList.remove('is-active'));
        };

        const syncChildPanelWidths = () => {
            cascade.style.removeProperty('--products-cascade-panel-width');

            const childPanelContent = cascade.querySelectorAll(
                '.products-cascade__panel:not(.products-cascade__panel--root) '
                + '.products-cascade__heading, '
                + '.products-cascade__panel:not(.products-cascade__panel--root) '
                + '.products-cascade__link',
            );
            const configuredWidth = parseFloat(getComputedStyle(cascade)
                .getPropertyValue('--products-cascade-panel-width')) || 0;
            const widestContent = Array.from(childPanelContent)
                .reduce((width, element) => Math.max(width, element.scrollWidth), 0);

            cascade.style.setProperty(
                '--products-cascade-panel-width',
                `${Math.ceil(Math.max(configuredWidth, widestContent))}px`,
            );
        };

        const positionMenu = () => {
            const toggleRect = toggle.getBoundingClientRect();
            const toggleText = toggle.querySelector('span');
            const navigation = toggle.closest('.header_nav') || toggle.closest('.navPages');
            const left = toggleText ? toggleText.getBoundingClientRect().left : toggleRect.left;
            const top = navigation ? navigation.getBoundingClientRect().bottom : toggleRect.bottom;

            menu.style.left = `${left}px`;
            menu.style.top = `${top}px`;
            overlay.style.top = `${top}px`;
        };

        const closeMenu = (returnFocus = false) => {
            cascade.classList.remove('is-open');
            toggle.setAttribute('aria-expanded', 'false');
            menu.setAttribute('aria-hidden', 'true');
            if (toggleIcon) toggleIcon.textContent = '+';
            resetPanels();

            if (returnFocus) toggle.focus();
        };

        const openMenu = () => {
            document.querySelectorAll('[data-products-cascade].is-open').forEach(openCascade => {
                if (openCascade === cascade) return;
                openCascade.classList.remove('is-open');
                openCascade.querySelector('[data-products-cascade-toggle]')?.setAttribute('aria-expanded', 'false');
                openCascade.querySelector('[data-products-cascade-menu]')?.setAttribute('aria-hidden', 'true');
            });

            const regularMegaMenu = document.querySelector('.mega-menu.active');
            regularMegaMenu?.classList.remove('active');
            positionMenu();
            cascade.classList.add('is-open');
            syncChildPanelWidths();
            toggle.setAttribute('aria-expanded', 'true');
            menu.setAttribute('aria-hidden', 'false');
            if (toggleIcon) toggleIcon.textContent = '-';
            window.requestAnimationFrame(positionCloseButton);
        };

        const activateItem = item => {
            const parentList = item.parentElement;

            if (!parentList) return;

            Array.from(parentList.children).forEach(sibling => {
                if (sibling === item) return;
                sibling.classList.remove('is-active');
                sibling.querySelectorAll('.products-cascade__item.is-active').forEach(descendant => descendant.classList.remove('is-active'));
                sibling.querySelectorAll('.products-cascade__panel.is-active').forEach(panel => panel.classList.remove('is-active'));
            });

            item.classList.add('is-active');
            const childPanel = Array.from(item.children).find(child => child.classList?.contains('products-cascade__panel'));

            if (childPanel) childPanel.classList.add('is-active');

            positionCloseButton();
        };

        toggle.addEventListener('click', event => {
            event.preventDefault();
            event.stopPropagation();

            if (cascade.classList.contains('is-open')) {
                closeMenu();
            } else {
                openMenu();
            }
        });

        cascade.querySelectorAll('[data-products-cascade-item]').forEach(item => {
            item.addEventListener('mouseenter', () => activateItem(item));
            item.addEventListener('focusin', () => activateItem(item));
        });

        closeButton.addEventListener('click', event => {
            event.preventDefault();
            closeMenu(true);
        });
        overlay.addEventListener('click', () => closeMenu(true));

        document.addEventListener('keydown', event => {
            if (event.key === 'Escape' && cascade.classList.contains('is-open')) closeMenu(true);
        });

        document.addEventListener('click', event => {
            if (cascade.classList.contains('is-open') && !cascade.contains(event.target)) closeMenu();
        });

        window.addEventListener('resize', () => {
            if (!cascade.classList.contains('is-open')) return;
            if (window.innerWidth <= 990) closeMenu();
            else {
                syncChildPanelWidths();
                positionMenu();
                window.requestAnimationFrame(positionCloseButton);
            }
        });
    });
};

function refreshMegaScrollUI(menuEl) {
    if (!menuEl) return;

    const cols = menuEl.querySelectorAll('.product-mega-item');

    cols.forEach(col => {
        const wrap = col.querySelector('.mega-scroll');
        const ul = col.querySelector('.mega-scroll ul');
        const btnUp = col.querySelector('.mega-scroll-arrow.up');
        const btnDown = col.querySelector('.mega-scroll-arrow.down');

        if (!wrap || !ul || !btnUp || !btnDown) return;

        const items = ul.querySelectorAll('li');

        if (items.length <= 6) {
            wrap.style.maxHeight = '';
            wrap.style.overflowY = 'visible';
            btnUp.style.display = 'none';
            btnDown.style.display = 'none';
            return;
        }

        const firstLi = items[0];
        const liRect = firstLi.getBoundingClientRect();
        const ulStyles = window.getComputedStyle(ul);
        const gap = parseFloat(ulStyles.rowGap || ulStyles.gap || '0') || 0;
        const rowHeight = liRect.height + gap;

        wrap.style.maxHeight = `${rowHeight * 6}px`;
        wrap.style.overflowY = 'auto';

        const canScroll = wrap.scrollHeight > wrap.clientHeight + 1;

        if (!canScroll) {
            btnUp.style.display = 'none';
            btnDown.style.display = 'none';
            return;
        }

        const atTop = wrap.scrollTop <= 1;
        const atBottom = (wrap.scrollTop + wrap.clientHeight) >= (wrap.scrollHeight - 1);

        btnUp.style.display = atTop ? 'none' : 'flex';
        btnDown.style.display = atBottom ? 'none' : 'flex';
    });
}

const initializeDesktopMegaMenu = () => {
    const toggleMegaMenu = (item, menu, icon, event) => {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        const openMenu = document.querySelector('.mega-menu.active');
        if (openMenu && openMenu !== menu) {
            openMenu.classList.remove('active');
            const openIcon = openMenu.closest('.has-mega-menu')?.querySelector('.toggle-icon');
            if (openIcon) openIcon.textContent = '+';
        }

        const willBeOpen = menu.classList.toggle('active');
        icon.textContent = willBeOpen ? '-' : '+';

        if (willBeOpen) {
            requestAnimationFrame(() => {
                refreshMegaScrollUI(menu);
                requestAnimationFrame(() => refreshMegaScrollUI(menu));
            });
        }
    };

    document.querySelectorAll('.nav-item.has-mega-menu').forEach(item => {
        const link = item.querySelector('a');
        const icon = item.querySelector('.toggle-icon');
        const menu = item.querySelector('.mega-menu');

        if (!link || !icon || !menu) return;

        link.addEventListener('click', event => toggleMegaMenu(item, menu, icon, event));
        icon.addEventListener('click', event => toggleMegaMenu(item, menu, icon, event));
    });

    document.addEventListener('click', () => {
        const openMenu = document.querySelector('.mega-menu.active');

        if (!openMenu) return;

        openMenu.classList.remove('active');

        const parent = openMenu.closest('.has-mega-menu');
        const toggleIcon = parent?.querySelector('.toggle-icon');

        if (toggleIcon) toggleIcon.textContent = '+';
    });
};

const initializeMobileMenu = () => {
    const hamburger = document.querySelector('.hamburger');
    const mobileMenu = document.querySelector('.mobile-menu');
    const mobileClose = document.querySelector('.mobile-close');
    const allLevels = document.querySelectorAll('.menu-level');

    if (!hamburger || !mobileMenu || !allLevels.length) return;

    const hideAllLevels = () => {
        allLevels.forEach(level => {
            level.classList.remove('current', 'leaving');
            level.setAttribute('aria-hidden', 'true');
        });
    };

    const openMobileMenu = () => {
        const firstLevel = document.querySelector('.menu-level.level-1');

        if (!firstLevel) return;

        mobileMenu.classList.add('active');
        hideAllLevels();
        firstLevel.classList.add('current');
        firstLevel.setAttribute('aria-hidden', 'false');
        hamburger.style.display = 'none';
    };

    const closeMobileMenu = () => {
        mobileMenu.classList.remove('active');
        hideAllLevels();

        setTimeout(() => {
            hamburger.style.removeProperty('display');
        }, 300);
    };

    hamburger.addEventListener('click', openMobileMenu);
    if (mobileClose) mobileClose.addEventListener('click', closeMobileMenu);

    document.querySelectorAll('.mobile-back-link').forEach(backBtn => {
        backBtn.addEventListener('click', event => {
            event.stopPropagation();

            const current = event.target.closest('.menu-level.current');
            if (!current) return;

            if (current.classList.contains('level-1')) {
                closeMobileMenu();
                return;
            }

            current.classList.remove('current');
            current.classList.add('leaving');
            current.setAttribute('aria-hidden', 'true');

            const parentLevelNum = current.classList.contains('level-2') ? 1 : 2;
            const parentPanel = document.querySelector(`.menu-level.level-${parentLevelNum}`);

            if (!parentPanel) return;

            parentPanel.classList.remove('leaving');
            parentPanel.classList.add('current');
            parentPanel.setAttribute('aria-hidden', 'false');
        });
    });

    document.querySelectorAll('.mobile-item.has-submenu .mobile-link').forEach(button => {
        button.addEventListener('click', event => {
            event.stopPropagation();

            const container = event.currentTarget.closest('.menu-level');
            if (!container) return;

            const thisLevelNum = container.classList.contains('level-1') ? 1 : 2;
            const dataTarget = event.currentTarget.closest('.mobile-item')?.getAttribute('data-target');
            const nextLevelNum = thisLevelNum + 1;
            const nextPanel = document.querySelector(`.menu-level.level-${nextLevelNum}[data-panel="${dataTarget}"]`);

            if (!nextPanel) return;

            container.classList.remove('current');
            container.classList.add('leaving');
            container.setAttribute('aria-hidden', 'true');

            nextPanel.classList.remove('leaving');
            nextPanel.classList.add('current');
            nextPanel.setAttribute('aria-hidden', 'false');

            const arrowSpan = event.currentTarget.querySelector('.mobile-arrow');
            if (arrowSpan) arrowSpan.style.transform = 'rotate(180deg)';
        });
    });

    document.addEventListener('click', event => {
        if (
            mobileMenu.classList.contains('active') &&
            !event.target.closest('.mobile-menu') &&
            !event.target.closest('.hamburger')
        ) {
            closeMobileMenu();
        }
    });

    allLevels.forEach(panel => {
        panel.addEventListener('transitionend', () => {
            if (panel.classList.contains('current')) {
                panel.querySelectorAll('.mobile-arrow').forEach(arrow => {
                    arrow.style.transform = 'rotate(0deg)';
                });
            }
        });
    });
};

const throttle = (fn, wait = 50) => {
    let last = Date.now();

    return function throttled(...args) {
        if (Date.now() - last > wait) {
            fn.apply(this, args);
            last = Date.now();
        }
    };
};

const toggleDesktopConsult = () => {
    const scrollY = window.pageYOffset;
    const innerH = window.innerHeight;
    const docH = document.documentElement.scrollHeight;
    const distanceBot = docH - (scrollY + innerH);
    const btn = document.querySelector('.fixed-action-btn');

    if (!btn) return;

    btn.style.display = distanceBot < 1100 ? 'none' : '';
};

const initializeConsultButton = () => {
    toggleDesktopConsult();
    window.addEventListener('scroll', throttle(toggleDesktopConsult));
    window.addEventListener('resize', throttle(toggleDesktopConsult));
};

const initializeMegaScrollColumns = () => {
    const megaItems = document.querySelectorAll('.mega-menu .product-mega-item');

    megaItems.forEach(col => {
        const ul = col.querySelector('ul');
        if (!ul || col.querySelector('.mega-scroll')) return;

        const pinnedLis = [];
        ul.querySelectorAll('li').forEach(li => {
            if (li.querySelector('a.Product-Menu-Button')) pinnedLis.push(li);
        });

        pinnedLis.forEach(li => ul.removeChild(li));

        const wrap = document.createElement('div');
        wrap.className = 'mega-scroll';
        ul.parentNode.insertBefore(wrap, ul);
        wrap.appendChild(ul);

        if (pinnedLis.length) {
            const pinnedWrap = document.createElement('div');
            const pinnedUl = document.createElement('ul');

            pinnedWrap.className = 'mega-pinned';
            pinnedUl.style.listStyle = 'none';
            pinnedUl.style.margin = '0';
            pinnedUl.style.padding = '0';
            pinnedUl.style.display = 'flex';
            pinnedUl.style.flexDirection = 'column';
            pinnedUl.style.gap = '8px';

            pinnedLis.forEach(li => pinnedUl.appendChild(li));
            pinnedWrap.appendChild(pinnedUl);
            col.appendChild(pinnedWrap);
        }

        const arrowSvg = `
            <svg viewBox="0 0 18 18" aria-hidden="true" focusable="false">
                <path d="M9 3 L16 14 H2 Z" fill="white"></path>
            </svg>
        `;
        const btnUp = document.createElement('button');
        const btnDown = document.createElement('button');

        btnUp.type = 'button';
        btnUp.className = 'mega-scroll-arrow up';
        btnUp.setAttribute('aria-label', 'Scroll up');
        btnUp.innerHTML = arrowSvg;

        btnDown.type = 'button';
        btnDown.className = 'mega-scroll-arrow down';
        btnDown.setAttribute('aria-label', 'Scroll down');
        btnDown.innerHTML = `<span style="display:block; transform: rotate(180deg);">${arrowSvg}</span>`;

        col.appendChild(btnUp);
        col.appendChild(btnDown);

        const getRowHeight = () => {
            const firstLi = ul.querySelector('li');
            if (!firstLi) return 40;

            const liRect = firstLi.getBoundingClientRect();
            const styles = window.getComputedStyle(ul);
            const gap = parseFloat(styles.rowGap || styles.gap || '0') || 0;

            return liRect.height + gap;
        };

        btnUp.addEventListener('click', event => {
            event.preventDefault();
            event.stopPropagation();
            wrap.scrollBy({ top: -getRowHeight() * 3, behavior: 'smooth' });
        });

        btnDown.addEventListener('click', event => {
            event.preventDefault();
            event.stopPropagation();
            wrap.scrollBy({ top: getRowHeight() * 3, behavior: 'smooth' });
        });

        wrap.addEventListener('scroll', () => {
            refreshMegaScrollUI(col.closest('.mega-menu'));
        });

        const menuEl = col.closest('.mega-menu');
        if (menuEl?.classList.contains('active')) {
            refreshMegaScrollUI(menuEl);
        }
    });
};

const initializeAISeller = () => {
    window.AISellerSettings = {
        agent_id: 'd8a7c803-aabf-4f31-acda-806378060585',
    };

    const existingAISeller = window.AISeller;

    if (typeof existingAISeller === 'function') {
        existingAISeller('update', window.AISellerSettings);
        return;
    }

    const queue = function aiSellerQueue() {
        queue.q.push(arguments);
    };

    queue.q = [];
    queue.q.push(['update', window.AISellerSettings]);
    window.AISeller = queue;

    const loadAISeller = () => {
        loadScript('https://d33t2173eag6fx.cloudfront.net/script/app/inbound-se-script/ai-seller.js', {
            async: 'true',
            type: 'text/javascript',
        });
    };

    if (document.readyState === 'complete') {
        loadAISeller();
    } else {
        window.addEventListener('load', loadAISeller, { once: true });
    }
};

let customScriptsInitialized = false;

export default function initializeCustomScripts() {
    if (customScriptsInitialized) return;

    customScriptsInitialized = true;

    ready(() => {
        updateAccountHeading();
        initializeSwiperSliders();
        toggleSectionsBasedOnScreenSize();
        initializeStickyHeader();
        initializeResponsiveMenu();
        initializeLoginPopup();
        initializeSubcatExpandVisibility();
        initializeMobileFlyoutSync();
        initializeReviewScroll();
        initializeSlickSliders();
        initializeDesktopNavHover();
        initializeProductsCascadeMenu();
        initializeDesktopMegaMenu();
        initializeMobileMenu();
        initializeConsultButton();
        initializeMegaScrollColumns();
        loadFontAwesome();
        initializeAISeller();

        window.addEventListener('resize', toggleSectionsBasedOnScreenSize);
    });
}
